import { defineComponent } from 'vue';
export default defineComponent({
  name: 'ATableColumnGroup',
  slots: ['title'],
  __ANT_TABLE_COLUMN_GROUP: true,
  render: function render() {
    return null;
  }
});